export enum TRIAL_SHOW_CASE_COURSES {
  MARKETING = 'marketing-3c3316',
  GESTAO_RH = 'gestao-de-recursos-humanos-b3f0c7',
  GESTAO_FINANCEIRA = 'gestao-financeira-cae91e',
  ADM = 'administracao-f1abd6',
  CIENCIA_COMPUTACAO = 'ciencia-da-computacao-49ca49',
  SISTEMAS_INFORMACAO = 'sistemas-de-informacao',
  ENG_COMPUTACAO = 'engenharia-da-computacao-9ffd1a',
  ADS = 'analise-e-desenvolvimento-de-sistemas',
  JOGOS_DIGITAIS = 'jogos-digitais',
}
